import type { FaireProductEntity } from "../../entity_types/product";

export const p_4couom35k1: FaireProductEntity = {
  token: "p_4couom35k1",
  type: "product",
  name: "Soft Baked Cinnamon Oatmeal Raisin Cookies - 7.2 oz Box",
  brandToken: "b_1q83xmlpct",
  brandName: "Maxine's Heavenly",
  imageUrl:
    "https://cdn.faire.com/fastly/0aadf7536618a6f34b273a689dc2ff620e45aaecacac0f5ce014d35e23a78475.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22132a83fcf97db49e0bc51bd7f316b11d86eb43beda02629dbaf00a4486e242.png",
    "https://cdn.faire.com/fastly/574fdd00538cdeee4be491ac083c41d093b85840b6aca0a0774d8f6d81f205f5.png",
    "https://cdn.faire.com/fastly/c085827f8b2466ba078773e2b4560f5b5e261c2c3494e84190dad653b89664f6.png",
  ],
  priceDollars: 5.81,
  description:
    "We add an extra touch of spicy-sweet cinnamon and plump, juicy raisins to really take you back in time. Like a hug from grandma!\n\nSWEETENED BY NATURE. We sweeten with coconut sugar and dates!\nTASTES HOMEMADE. Our cookies hold true to mom’s homemade cookie experience.\nBETTER-FOR-YOU. No empty calories! Just nutrient-rich ingredients like whole-grain oats.\nMADE FOR MORE TO ENJOY. Low sugar and certified gluten free, vegan, kosher, and non-GMO.\n\nShelf life - 300 days.\n7.2 oz.",
  tags: [],
  msrpDollars: 9.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:17.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
